import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { skuListAndConfig, reviewKpis } from 'src/helper/static';
import { ReviewKPIs } from '../../modals/planogram';
import { Observable, SubscriptionLike } from 'rxjs';
import { PlanogramStateService } from 'src/services/planogram-state.service';
import { PlanogramNewComponentComponent } from '../planogram-new-component/planogram-new-component.component';

@Component({
  selector: 'app-planogram-new-builder',
  templateUrl: './planogram-new-builder.component.html',
  styleUrl: './planogram-new-builder.component.css',
})
export class PlanogramNewBuilderComponent implements OnInit {
  @ViewChild(PlanogramNewComponentComponent)
  planogramNewComponentComponent!: PlanogramNewComponentComponent;
  @Input() is_display: boolean = false;
  @Input() show_sku_list: boolean = true;
  @Input() planogram_id: number;
  @Input() isReset: boolean = false;
  @Input() planogram_details: any;
  @Input() save: boolean;
  @Output() resetSkusInPlanogram = new EventEmitter();
  placed_sku_list = {};
  drop_item_ids: string[] = [];
  representation_chip_selected: string = 'category_distribution';
  checklists: any[];

  constructor(private planogramState: PlanogramStateService) {}
  ngOnInit(): void {
    //this.planogramState.getReviewKpis({id:this.planogram_id})
  }

  tabSelection(e: any) {
    if (e['index'] === 2) {
    }
  }

  addDropItemId = (obj: { id: string; row_no: number; position: number }) => {
    if (!this.drop_item_ids.includes(obj.id)) this.drop_item_ids.push(obj.id);
  };

  filterRepresentation(filter: string) {
    this.representation_chip_selected = filter;
  }

  resetPlanogram(event: any) {
    this.resetSkusInPlanogram.emit({ reset: true });
    this.isReset = event.reset;
  }

  saveCustomizedPlanogram() {
    this.planogramNewComponentComponent.saveCustomizedPlanogram();
  }
}
